<template>
  <v-container
    fluid
    id="MyWorkOrders"
    class="pa-0 pa-sm-3"
    v-if="['Office', 'Project Manager'].includes(user.role)"
  >
    <v-row wrap justify="center">
      <v-col cols="12" xs="12" class="headline pb-0"
        >Work Orders
        <v-btn
          color="primary"
          small
          class="ml-4"
          @click.stop="openPackage"
          :disabled="
            !selectedWorkOrders.length ||
              selectedWorkOrders.some((wo) => wo.status !== 'open')
          "
          ><v-icon small left>library_books</v-icon> package for billing</v-btn
        >

        <!-- COMBINE FOR BILLING -->
        <v-dialog
          v-model="dialogPackage"
          max-width="600"
          transition="dialog-bottom-transition"
        >
          <v-card color="grey lighten-4" v-if="selectedWorkOrders.length">
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="dialogPackage = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Package for Billing & Approval</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  dark
                  text
                  @click="createPackage"
                  :disabled="submittingPackage"
                  >Create Package</v-btn
                >
              </v-toolbar-items>
            </v-toolbar>
            <v-container grid-list-xl>
              <v-row>
                <v-col>
                  <h1 class="headline">
                    {{ selectedWorkOrders[0].jobSite.street }}
                    <span
                      class="font-weight-regular"
                      v-if="selectedWorkOrders[0].jobSite.street2"
                    >
                      {{ selectedWorkOrders[0].jobSite.street2 }}</span
                    >
                    {{ selectedWorkOrders[0].jobSite.city }}
                    {{ selectedWorkOrders[0].jobSite.postalCode }}
                  </h1>
                  <div class="mt-3">
                    <v-select
                      v-model="approvers"
                      :items="pmList"
                      attach
                      chips
                      small-chips
                      dense
                      label="Select Approvers"
                      hint="Package will automatically be sent to billing when all approvals are complete."
                      persistent-hint
                      multiple
                      return-object
                      item-text="name"
                      deletable-chips
                    >
                    </v-select>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <!-- TICKET SUMMARY -->
                  <!-- LABOR -->
                  <v-card class="mb-4">
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left" width="50%">Labor</th>
                            <th class="text-right" width="100">Hours</th>
                            <th class="text-right" width="100">Rate</th>
                            <th class="text-right" width="100">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(labor, index) in laborCombined"
                            :key="index"
                          >
                            <td class="text-left">{{ labor.type }}</td>
                            <td class="text-right">
                              <input
                                dense
                                type="number"
                                outlined
                                v-model.number="labor.hours"
                                style="width:60px;text-align:right;color:#1e88e5"
                              />
                            </td>
                            <td class="text-right">
                              ${{ labor.rate.toFixed(2) }}
                            </td>
                            <td class="text-right">
                              ${{ (labor.hours * labor.rate).toFixed(2) }}
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">SUBTOTAL</td>
                            <td class="text-right"></td>
                            <td class="text-right"></td>
                            <td class="text-right">
                              ${{ laborCombinedSum.toFixed(2) }}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                  <!-- MATERIALS -->
                  <v-card class="mb-4">
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left" width="50%">Materials</th>
                            <th class="text-right" width="100">QTY</th>
                            <th class="text-right" width="100">Value</th>
                            <th class="text-right" width="100">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(material, index) in materialCombined"
                            :key="index"
                          >
                            <td class="text-left">{{ material.title }}</td>
                            <td class="text-right">
                              <input
                                dense
                                type="number"
                                outlined
                                v-model.number="material.qty"
                                style="width:60px;text-align:right;color:#1e88e5"
                              />
                            </td>
                            <td class="text-right">
                              <input
                                v-if="material.editable"
                                dense
                                type="number"
                                outlined
                                v-model.number="material.unitPrice"
                                style="width:60px;text-align:right;color:#1e88e5"
                              />
                              <span v-else
                                >${{ material.unitPrice.toFixed(2) }}</span
                              >
                            </td>
                            <td class="text-right">
                              ${{
                                (material.qty * material.unitPrice).toFixed(2)
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">SUBTOTAL</td>
                            <td class="text-right"></td>
                            <td class="text-right"></td>
                            <td class="text-right">
                              ${{ materialCombinedSum.toFixed(2) }}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                  <!-- DEBRIS -->
                  <v-card class="mb-4">
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left" width="50%">Debris</th>
                            <th class="text-right" width="100">Yards</th>
                            <th class="text-right" width="100">Rate</th>
                            <th class="text-right" width="100">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="text-left">Yardage</td>
                            <td class="text-right">
                              <input
                                dense
                                type="number"
                                outlined
                                v-model.number="debrisYardageCombined"
                                style="width:60px;text-align:right;color:#1e88e5"
                              />
                            </td>
                            <td class="text-right">$60.00</td>
                            <td class="text-right">
                              ${{
                                (debrisYardageCombined * debrisRate).toFixed(2)
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                  <!-- DISCOUNTS -->
                  <v-card class="mb-4">
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              Adjustments / Discounts
                              <a
                                @click.prevent="addAdjustment"
                                style="border:solid 1px gray;padding: 0 8px;border-radius:2px"
                                class="ml-4"
                                >+ add</a
                              >
                            </th>
                            <th class="text-right" width="100"></th>
                            <th class="text-right" width="100">Amount</th>
                          </tr>
                        </thead>
                        <tbody v-if="adjustments.length">
                          <tr v-for="(adjustment, ix) in adjustments" :key="ix">
                            <td class="text-left pr-0">
                              <input
                                dense
                                type="text"
                                outlined
                                v-model="adjustment.type"
                                style="width:100%;padding-left:5px;color:#1e88e5"
                              />
                            </td>
                            <td class="text-right">
                              <a
                                @click.prevent="adjustments.splice(ix, 1)"
                                style="border:solid 1px gray;padding: 0 8px;border-radius:2px;color:#163758;font-weight:bold;font-size:.75rem"
                                class="ml-4"
                                >remove</a
                              >
                            </td>
                            <td class="text-right">
                              <strong>
                                <input
                                  dense
                                  type="number"
                                  outlined
                                  v-model.number="adjustment.amount"
                                  style="width:60px;text-align:right;color:#1e88e5"
                                />
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                  <!-- TICKET SUMMARY -->
                  <v-card>
                    <v-simple-table dense>
                      <template v-slot:default>
                        <tbody>
                          <tr>
                            <td class="text-left">Tool Mobilization</td>
                            <td class="text-right">
                              <strong>
                                <input
                                  dense
                                  type="number"
                                  outlined
                                  v-model.number="toolMobilization"
                                  style="width:60px;text-align:right;color:#1e88e5"
                                />
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">Sub Total</td>
                            <td class="text-right">
                              <strong>${{ subTotal.toFixed(2) }}</strong>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">
                              Overhead and Profit (15%)
                            </td>
                            <td class="text-right">
                              <strong
                                >${{ (subTotal * 0.15).toFixed(2) }}</strong
                              >
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
            <v-container grid-list-xl>
              <v-row>
                <v-col
                  cols="12"
                  xs="12"
                  v-for="wo in selectedWorkOrders"
                  :key="wo.id"
                >
                  <work-order-ticket :workOrder="wo" />
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-dialog>
        <!-- COMBINE FOR BILLING -->
      </v-col>

      <!--  WORK ORDERS -->
      <v-col cols="12" xs="12" class="">
        <v-card>
          <v-tabs>
            <v-tab @click="workOrderType('open')"
              >Open<span class="caption ml-1 grey--text"></span
            ></v-tab>
            <v-tab @click="workOrderType('closed')">Closed</v-tab>
            <v-tab @click="workOrderType('cancelled')">Cancelled</v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-data-table
            :items="currentWorkOrders"
            :loading="loadingWorkOrders"
            loading-text="Loading....please wait."
            :headers="headers"
            disable-sort
            show-select
            v-model="selectedWorkOrders"
          >
            <template v-slot:item.orderNumber="{ item }">
              <span class="subtitle-2">#{{ item.orderNumber }}</span>
            </template>
            <template v-slot:item.orderedBy="{ item }">
              {{ item.orderedBy.firstName }}
              {{ item.orderedBy.lastName }}
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                small
                color="amber lighten-3"
                v-if="item.status == 'open'"
              >
                open
              </v-chip>
              <v-chip
                small
                color="red lighten-3"
                v-if="item.status == 'closed'"
              >
                closed
              </v-chip>
              <v-chip small v-if="item.status == 'cancelled'">
                cancelled
              </v-chip>
            </template>
            <template v-slot:item.orderDate="{ item }">{{
              item.orderDate.toDate() | moment("MMM Do [at] h:mma")
            }}</template>
            <template v-slot:item.dateCompleted="{ item }">{{
              item.dateCompleted | moment("MMM Do, YYYY")
            }}</template>
            <template v-slot:item.viewOrder="{ item }">
              <v-btn
                color="primary"
                small
                outlined
                text
                @click.stop="showTicket(item)"
                >view work order</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>

      <!-- PACKAGES -->
      <v-col cols="12" xs="12" class="headline pb-0">Packages</v-col>
      <v-col cols="12" xs="12" class="">
        <v-card>
          <v-tabs>
            <v-tab @click="pendingPackages = true"
              >Pending<span class="caption ml-1 grey--text"></span
            ></v-tab>
            <v-tab @click="pendingPackages = false">Sent to billing</v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-data-table
            :items="filteredPackages"
            :loading="loadingPackages"
            loading-text="Loading....please wait."
            :headers="packagesHeaders"
            disable-sort
            :search="search"
            dense
            :items-per-page="50"
            :footer-props="{ itemsPerPageOptions: [50, 100, -1] }"
            v-model="selectedWorkOrders"
          >
            <template v-slot:top>
              <v-toolbar flat color="white" class="pt-1">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Filter by site address"
                  hide-details
                  outlined
                  dense
                ></v-text-field>
              </v-toolbar>
            </template>
            <template v-slot:item.address="{ item }">
              <span class="subtitle-2"
                >{{ item.workOrders[0].jobSite.street }} ({{
                  item.workOrders[0].jobSite.jobId
                }})</span
              ><span v-if="!item.approved"
                ><v-chip class="ml-2" x-small color="amber lighten-2"
                  >pending approval</v-chip
                ></span
              >
            </template>
            <template v-slot:item.workOrderIds="{ item }">
              <span class="subtitle-2"
                >#{{ item.workOrderIds.join(", #") }}</span
              >
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                small
                color="amber lighten-3"
                v-if="item.status == 'open'"
              >
                open
              </v-chip>
              <v-chip
                small
                color="red lighten-3"
                v-if="item.status == 'closed'"
              >
                closed
              </v-chip>
              <v-chip small v-if="item.status == 'cancelled'">
                cancelled
              </v-chip>
            </template>
            <template v-slot:item.subTotal="{ item }">
              <span v-if="item.subTotal"
                >${{ (item.subTotal * 1.15).toFixed(2) }}</span
              >
            </template>
            <template v-slot:item.viewPackage="{ item }">
              <v-btn
                color="primary"
                small
                outlined
                text
                :to="`/work-orders/manage/packages/${item.id}`"
                >view Package</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="600">
      <work-order-ticket
        :workOrder="currentTicket"
        @close="closeTicket"
        :showClose="true"
      />
    </v-dialog>
  </v-container>
</template>
<script>
import fb from "@/main";
import { mapState } from "vuex";
import workOrderTicket from "@/components/workOrders/WorkOrderTicket";
import { groupBy, sumBy } from "lodash";
export default {
  components: {
    workOrderTicket: workOrderTicket,
  },
  data() {
    return {
      type: "open",
      search: "",
      loadingWorkOrders: true,
      submittingPackage: false,
      loadingPackages: false,
      dialog: false,
      dialogPackage: false,
      selectedWorkOrders: [],
      workOrders: [],
      workOrderPackages: [],
      currentTicket: null,
      packages: [],
      approvers: [],
      laborCombined: [],
      materialCombined: [],
      debrisYardageCombined: 0,
      pmList: [],
      debrisRate: 60,
      toolMobilization: 0,
      adjustments: [],
      pendingPackages: true,
      headers: [
        {
          text: "Order",
          align: "left",
          value: "orderNumber",
        },
        {
          text: "Site Address",
          align: "left",
          value: "jobSite.street",
          sortable: true,
        },
        { text: "Date", value: "orderDate" },
        { text: "Completed", value: "dateCompleted" },
        { text: "Foreman", value: "orderedBy" },
        { text: "Status", value: "status", align: "right" },
        { text: "", value: "viewOrder", align: "right", width: "200" },
      ],
      packagesHeaders: [
        { text: "Address", value: "address" },
        { text: "Work Orders", value: "workOrderIds" },
        { text: "Total", value: "subTotal" },
        { text: "", value: "viewPackage", align: "right", width: "200" },
      ],
    };
  },
  computed: {
    ...mapState(["user"]),
    adjustmentsTotal() {
      return sumBy(this.adjustments, (a) => a.amount);
    },
    currentWorkOrders() {
      return this.workOrders.filter((wo) => wo.status == this.type);
    },
    laborCombinedSum() {
      return sumBy(this.laborCombined, (lc) => lc.hours * lc.rate);
    },
    materialCombinedSum() {
      return sumBy(this.materialCombined, (mc) => mc.qty * mc.unitPrice);
    },
    subTotal() {
      return (
        this.laborCombinedSum +
        this.materialCombinedSum +
        this.toolMobilization +
        this.debrisYardageCombined * this.debrisRate -
        this.adjustmentsTotal
      );
    },
    filteredPackages: function() {
      return this.workOrderPackages.filter((p) => {
        return p.approved === !this.pendingPackages;
      });
    },
  },
  async created() {
    try {
      await this.getWorkOrders();
      await this.getWorkOrderPackages();
      this.getPmList();
      if (this.$route.query.viewWorkOrder) {
        const order = this.workOrders.find(
          (wo) => wo.orderNumber == this.$route.query.viewWorkOrder
        );
        if (order) this.showTicket(order);
      }
    } catch (error) {
      alert(error);
      // alert("Error getting work orders");
      this.loadingWorkOrders = false;
    }
  },
  methods: {
    openPackage() {
      let sameJobCheck = this.selectedWorkOrders.every(
        (val) => this.selectedWorkOrders[0].jobSite.id === val.jobSite.id
      );
      if (this.selectedWorkOrders.length > 1 && !sameJobCheck) {
        alert("All work orders selected must be the from the same job.");
        return;
      }
      this.laborCombined = [];
      this.materialCombined = [];
      this.debrisYardageCombined = 0;
      this.approvers = [];
      this.dialogPackage = true;
      this.debrisYardageCombined = sumBy(this.selectedWorkOrders, (sw) => {
        return sw.debrisYardage || 0;
      });

      let allLabor = this.selectedWorkOrders.flatMap((cwo) => cwo.labor);
      allLabor = allLabor.map((al) => {
        return { totalHours: al.hours * al.qty, ...al };
      });
      const groupedLabor = groupBy(allLabor, "type");
      for (const type in groupedLabor) {
        this.laborCombined.push({
          type: type,
          hours: sumBy(groupedLabor[type], "totalHours"),
          rate: groupedLabor[type][0].rate,
        });
      }

      let allMaterial = this.selectedWorkOrders.flatMap(
        (cwo) => cwo.partsMaterials
      );
      const groupedMaterial = groupBy(allMaterial, "title");
      for (const title in groupedMaterial) {
        this.materialCombined.push({
          title: title,
          qty: sumBy(groupedMaterial[title], "qty"),
          editable: groupedMaterial[title][0].editable || false,
          unitPrice: groupedMaterial[title][0].unitPrice,
        });
      }
    },
    workOrderType(type) {
      this.selectedWorkOrders = [];
      this.type = type;
    },
    closeTicket() {
      this.dialog = false;
    },
    addAdjustment() {
      this.adjustments.push({
        type: "-- describe adjustment here --",
        amount: 0,
      });
    },
    showTicket(ticket) {
      this.currentTicket = null;
      this.currentTicket = { ...ticket };
      this.dialog = true;
    },
    async getPmList() {
      const pmList = await fb.db
        .collection("users")
        .where("role", "==", "Project Manager")
        .get();
      this.pmList = [];
      pmList.forEach((u) => {
        this.pmList.push({
          name: u.data().firstName + " " + u.data().lastName,
          email: u.data().email,
          id: u.id,
        });
      });
    },
    async getWorkOrders() {
      this.loadingWorkOrders = true;
      const workOrders = await fb.workOrders_DB
        .orderBy("orderDate", "desc")
        .limit(100)
        .get();
      this.workOrders = [];
      workOrders.forEach((u) => {
        this.workOrders.push({
          id: u.id,
          ...u.data(),
        });
      });
      this.loadingWorkOrders = false;
    },
    async getWorkOrderPackages() {
      this.loadingPackages = true;
      const workOrderPackages = await fb.db
        .collection("workOrderPackages")
        .orderBy("createDate", "desc")
        .limit(300)
        .get();
      this.workOrderPackages = [];
      workOrderPackages.forEach((u) => {
        this.workOrderPackages.push({
          id: u.id,
          ...u.data(),
        });
      });
      this.workOrderPackages.forEach((w) => {
        w.address = w.workOrders[0].jobSite.address;
      });
      this.loadingPackages = false;
    },
    async createPackage() {
      if (this.approvers.length) {
        this.approvers = this.approvers.map((a) => {
          return { approved: false, ...a };
        });
      }
      if (this.adjustments.length) {
        this.adjustments = this.adjustments.filter((a) => a.amount > 0);
      }
      this.submittingPackage = true;
      const workOrderPackage = {
        createdBy: this.user,
        createDate: fb.timestamp,
        workOrderIds: this.selectedWorkOrders.map((wo) => wo.orderNumber),
        workOrders: this.selectedWorkOrders,
        status: "open",
        approvers: this.approvers || [],
        approved: this.approvers.length ? false : true,
        laborCombined: this.laborCombined,
        materialCombined: this.materialCombined,
        debrisYardageCombined: this.debrisYardageCombined || 0,
        toolMobilization: this.toolMobilization,
        adjustments: this.adjustments || [],
        jobSiteId: this.selectedWorkOrders[0].jobSite.id,
        subTotal: this.subTotal,
      };

      const packageRes = await fb.db
        .collection("workOrderPackages")
        .add(workOrderPackage);

      var batch = fb.db.batch();
      this.selectedWorkOrders.forEach((wo) => {
        var ref = fb.workOrders_DB.doc(wo.orderNumber);
        batch.update(ref, {
          status: "closed",
          closedBy: this.user,
          closeDate: fb.timestamp,
          packageId: packageRes.id,
        });
      });
      if (!this.approvers.length) {
        const sendToBilling = await fb.functions.httpsCallable(
          "sendWorkOrdersPackageToBilling"
        );
        await sendToBilling({
          order: this.selectedWorkOrders[0],
          workOrderPackageId: packageRes.id,
        });
      }
      await batch.commit();
      this.getWorkOrders();
      this.getWorkOrderPackages();
      this.submittingPackage = false;
      this.selectedWorkOrders = [];
      this.dialogPackage = false;
    },
  },
};
</script>
